/**
 * Timestamps are stored and sent as ISO-8601 UTC. Only the browser knows what
 * timezone the reader is in, so the conversion happens here -- the server
 * renders the instant and never guesses at a local time.
 *
 * If this never runs, the page still shows the UTC the server wrote, labelled
 * as UTC. A wrong local time would be worse than an honest foreign one.
 */
export function localiseTimes(root: ParentNode = document) {
  root.querySelectorAll<HTMLTimeElement>('time[datetime]').forEach(el => {
    const d = new Date(el.dateTime);
    // An unparseable timestamp is left exactly as the server sent it.
    if (Number.isNaN(d.getTime())) return;
    el.textContent = el.dataset.dateOnly
      ? d.toLocaleDateString()
      : d.toLocaleString();
    el.title = el.dateTime;
  });
}

localiseTimes();
